import { CopyOutlined, DeleteOutlined, ExclamationCircleOutlined, PauseOutlined, PlayCircleOutlined } from "@ant-design/icons";
import { Badge, Button, Flex, message, Modal, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { renderBadge } from "./helper";
import { deleteAccountScan, toggleAccountScan } from "../../../api/diagnose_dashboard/scan_setup";

function ScanUrlModal({ scanUrlData, scanUrlModalOpen, onClose, refreshBulkScanDetailsTable, accountId, setScanUrlData}) {
  const [modal, contextHolder] = Modal.useModal();
  const [loading, setLoading] = useState(false);
  
  const tableData = scanUrlData.scan_urls.map((scanData, index) => ({
    url: scanData.url,
    scan_ids: scanData.id,
    status: scanData.status,
    enabled: scanData.enabled
  }));
  const onToggleState = async (evt, record) => {
    evt.stopPropagation();
    evt.preventDefault();

    try {
      setLoading(true);
      await toggleAccountScan(
        { accId: accountId },
        { scan_id: record.scan_ids, enabled: !record.enabled }
      );
      const updatedBulkScans = await refreshBulkScanDetailsTable();
      const updatedModalData = updatedBulkScans.find(
        (item) =>
          item.zone === scanUrlData.zone &&
          item.region === scanUrlData.region &&
          item.consent_type === scanUrlData.consent_type
      );
      if (updatedModalData && updatedModalData?.scan_urls?.length) {
        setScanUrlData(updatedModalData);
      } else {
        onClose();
      }
    } catch (error) {
      console.error("Error on toggle scans: ", error);
    } finally {
      setLoading(false);
    }
  };

  const onDelete = async (evt, record) => {
    evt.stopPropagation();
    evt.preventDefault();
    const confirm = await modal.confirm({
      title: "Delete Scan",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure you want to delete the scan?",
      okText: "Delete",
      cancelText: "Cancel",
    });
    try {
      if (confirm) {
        setLoading(true);
        await deleteAccountScan({
          accId: accountId,
          scan_id: record.scan_ids,
        });
        const updatedBulkScans = await refreshBulkScanDetailsTable();
        const updatedModalData = updatedBulkScans.find(
          (item) =>
            item.zone === scanUrlData.zone &&
            item.region === scanUrlData.region &&
            item.consent_type === scanUrlData.consent_type
        );
        if (updatedModalData && updatedModalData?.scan_urls?.length) {
          setScanUrlData(updatedModalData);
        } else {
          onClose();
        }
        message.success("Scan deleted successfully!");
      } else {
        return;
      }
    } catch (error) {
      console.error("Error deleting scans: ", error);
      message.error("Failed to delete scans");
    } finally {
      setLoading(false);
    }
  };
  const scanTable = [
    {
      title: "Scan ID",
      dataIndex: "scan_ids",
      key: "scan_ids",
      ellipsis: true,
    },
    {
      title: "Scan URL",
      dataIndex: "url",
      key: "url",
      ellipsis: true,
      width: 220,
    },
    {
      title: "Scan Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        return renderBadge(status)
      }
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => { 
        
        return (
          <Flex justify="space-between">
            <Tooltip title={record.enabled ? "Disable" : "Enable"}>
              <Button
                type="link"
                onClick={(e) => onToggleState(e, record)}
                icon={
                  record.enabled ? <PauseOutlined /> : <PlayCircleOutlined />
                }
              />
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                type="link"
                onClick={(e) => onDelete(e, record)}
                icon={<DeleteOutlined />}
              />
            </Tooltip>
          </Flex>
        );
      },
      width: 140,
    },
  ];
  return (
    <Modal
      title={`Scan IDs & URLs (${scanUrlData.zone || "Unknown Zone"} - ${
        scanUrlData.region || "Unknown Region"
      })`}
      width={720}
      open={scanUrlModalOpen}
      okButtonProps={{ style: { display: "none" } }}
      onCancel={onClose}
      closable={true}
      className="scan-url-modal"
      cancelButtonProps={{
        type:'link'
      }}
    >
      <Table
        columns={scanTable}
        dataSource={tableData}
        rowKey={(record, index) => index}
        pagination={false}
        loading={loading}
        scroll={{ y: 400 }}
      />
      {contextHolder}
    </Modal>
  );
}

export default ScanUrlModal;
